<template>
<div class="com-file-list">
  <ComFile v-bind="$attrs" v-on="$listeners"  v-for="(f,index) in list" @delete="handleDelete($event,index)" :key="f.id" :file="f" 
></ComFile>
</div>

</template>
<script>
import ComFile from '@/components/common/com-file';
export default {
  name:'ComFileList',
  components:{
    ComFile
  },
  props:{
    list:{
      type:Array
    }
  },
  methods:{
    handleDownLoad(){

    },
    handleDelete(file,index){
      console.log(file,index);
      // this.$emit('delete',file,index);
    }
  }
}
</script>
<style lang='less' scoped>
.com-file-list{
  justify-content: flex-start;
  align-items:top;
  .com-file{
    margin-bottom:8px;
    margin-right:12px;
  }
  // .com-file + .com-file{
  //   margin-left:12px;
  // }
}
</style>